
<router-outlet></router-outlet>




<!-- loading screen -->
<app-loading-screen></app-loading-screen>


<!-- toast -->
<!-- <ima-toast></ima-toast> -->
